<template>
  <div :class="{'loading': loading, 'loading hidden': !loading}">
    <div class="container mt-5">
      <div class="row">
        <div class="col-12 text-center">

          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>

        </div>
        <!-- /.col-12 -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container -->
  </div>
  <!-- /.loading -->
</template>

<script>
  export default {
    name: 'Loading',
    props: {
      loading: Boolean
    }
  };
</script>

<style scoped lang="scss">
  .hidden {
    display: none !important;
  }

  .lds-ring {
    position: relative;

    padding-top: 100px;

    display: inline-block;
    width: 64px;
    height: 64px;
  }

  @media (min-width: 1200px) {
    .lds-ring {
      position: fixed;
      top: 50%;
      left: 50%;

      padding: 0;

      transform: translate(-50%, -110px);
    }
  }

  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 51px;
    height: 51px;
    margin: 6px;
    border: 6px solid #c34338;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #c34338 transparent transparent transparent;
  }

  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }

  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }

  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
